module.exports = __webpack_public_path__ + "media/27.be4482bf.mp3";